// HANDLER: Theme
const REGISTERED_THEMES: Themes = {
  default: {
    mode: 'dark',
    background_avatar: 'rgba(165, 167, 231, 0.3)',
    background_secondary: '#1F1E25',
    background_tooltip: '#35343B',
    background: '#16151B',
    bracket_background_default: '#24242D',
    bracket_background_loser: '#1F1E25',
    bracket_match_selection: 'linear-gradient(90deg, #fa6400 0%, #ffddc7 50%, #fa6400 100%)',
    bracket_minimap_background: '#262631',
    bracket_minimap_border: '#52525E',
    bracket_minimap_content: '#39394A',
    bracket_minimap_viewport_border: '#6769EB',
    bracket_liaison: '#211F27',
    component_gauge_background: '#2F2E38',
    component_gauge_circle_background: '#2F2E38',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#ED5565',
    component_radar_team_1: '#6769EB',
    component_radar_team_2: '#06D6A0',
    component_timeline_lines: '#89878C',
    data_loser: '#ED5565',
    data_strong: '#6769EB',
    data_tie: '#FFB333',
    data_weak: '#A5A7E7',
    data_winner: '#35FFC6',
    error_accent: '#6769EB',
    error_back: 'rgba(165, 167, 231, 0.3)',
    font_family_titles: 'avenir',
    font_family: 'avenir',
    global_background_protection: 'transparent',
    global_border: '#211F27',
    global_focus: '#89878C',
    global_image_blur: 'rgb(22, 21, 27) 50%, rgba(22, 21, 27, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#6769EB',
    text_overlay_secondary: '#89878C',
    text_overlay: '#FFFFFF',
    text_secondary: '#89878C',
    text_tertiary: '#C0C0C4',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  'pixel-bet': {
    mode: 'light',
    background_avatar: '#5C14C5',
    background_secondary: '#7A1BFF',
    background_tooltip: '#5C14C5',
    background: '#471099',
    bracket_background_default: '#24242D',
    bracket_background_loser: '#1F1E25',
    bracket_match_selection: 'linear-gradient(90deg, #fa6400 0%, #ffddc7 50%, #fa6400 100%)',
    bracket_minimap_background: '#262631',
    bracket_minimap_border: '#52525E',
    bracket_minimap_content: '#39394A',
    bracket_minimap_viewport_border: '#6769EB',
    bracket_liaison: '#5C14C5',
    component_gauge_background: '#8431FB',
    component_gauge_circle_background: '#8431FB',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#23D9B7',
    component_radar_team_1: '#FF006F',
    component_radar_team_2: '#F28123',
    component_timeline_lines: '#5C14C5',
    data_loser: '#FF2966',
    data_strong: '#FF006F',
    data_tie: '#FF9475',
    data_weak: '#FF70AE',
    data_winner: '#35FFC6',
    error_accent: '#450A9C',
    error_back: '#CAA4FF',
    font_family_titles: 'avenir',
    font_family: 'avenir',
    global_background_protection: 'transparent',
    global_border: '#5C14C5',
    global_focus: '#CAA4FF',
    global_image_blur: 'rgb(71, 16, 153) 50%, rgba(71, 16, 153, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#FFFFFF',
    text_overlay_secondary: '#CAA4FF',
    text_overlay: '#FFFFFF',
    text_secondary: '#CAA4FF',
    text_tertiary: '#CAA4FF',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  entain: {
    mode: 'dark',
    background_avatar: 'rgba(165, 167, 231, 0.3)',
    background_secondary: '#1F1E25',
    background_tooltip: '#35343B',
    background: '#16151B',
    bracket_background_default: '#24242D',
    bracket_background_loser: '#1F1E25',
    bracket_match_selection: 'linear-gradient(90deg, #fa6400 0%, #ffddc7 50%, #fa6400 100%)',
    bracket_minimap_background: '#262631',
    bracket_minimap_border: '#52525E',
    bracket_minimap_content: '#39394A',
    bracket_minimap_viewport_border: '#6769EB',
    bracket_liaison: '#464c54',
    component_gauge_background: '#2F2E38',
    component_gauge_circle_background: '#2F2E38',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#ff4a4b',
    component_radar_team_1: '#ff5588',
    component_radar_team_2: '#ff903e',
    component_timeline_lines: '#464c54',
    data_loser: '#ED5565',
    data_strong: '#ff903e',
    data_tie: '#ff903e',
    data_weak: '#ffc499',
    data_winner: '#35FFC6',
    error_accent: '#ff903e',
    error_back: '#ffc499',
    font_family_titles: 'HelveticaNeue',
    font_family: 'HelveticaNeue',
    global_background_protection: 'transparent',
    global_border: '#464c54',
    global_focus: '#89878C',
    global_image_blur: 'rgb(22, 21, 27) 50%, rgba(22, 21, 27, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#ff903e',
    text_overlay_secondary: '#d3d3d3',
    text_overlay: '#FFFFFF',
    text_secondary: '#d3d3d3',
    text_tertiary: '#C0C0C4',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 207, 255, 0.6)',
    vg_lol_blue: '#55cfd7',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(255, 74, 75, 0.6)',
    vg_lol_red: '#ff4a4b',
    vg_lol_water_drake: '#87B6A7'
  },
  inplaysoft: {
    mode: 'dark',
    background_avatar: 'rgba(165, 167, 231, 0.3)',
    background_secondary: '#434462',
    background_tooltip: '#585973',
    background: '#2e2f50',
    bracket_background_default: '#24242D',
    bracket_background_loser: '#1F1E25',
    bracket_match_selection: 'linear-gradient(90deg, #fa6400 0%, #ffddc7 50%, #fa6400 100%)',
    bracket_minimap_background: '#262631',
    bracket_minimap_border: '#52525E',
    bracket_minimap_content: '#39394A',
    bracket_minimap_viewport_border: '#6769EB',
    bracket_liaison: '#202138',
    component_gauge_background: '#252640',
    component_gauge_circle_background: '#252640',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#ff2424',
    component_radar_team_1: '#6260ff',
    component_radar_team_2: '#fed01a',
    component_timeline_lines: '#202138',
    data_loser: '#ff5050',
    data_strong: '#fecb00',
    data_tie: '#fecb00',
    data_weak: '#ffea99',
    data_winner: '#45b050',
    error_accent: '#fecb00',
    error_back: 'rgba(153, 159, 200, 0.3)',
    font_family_titles: 'Rubik',
    font_family: 'Rubik',
    global_background_protection: 'transparent',
    global_border: '#202138',
    global_focus: '#89878C',
    global_image_blur: 'rgb(46, 47, 80) 50%, rgba(46, 47, 80, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #292780 0%, #18174C 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#fecb00',
    text_overlay_secondary: '#9797A8',
    text_overlay: '#FFFFFF',
    text_secondary: '#9797A8',
    text_tertiary: '#89878c',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  favbet: {
    mode: 'light',
    background_avatar: 'rgba(0, 0, 85, 0.3)',
    background_secondary: '#e3e3e3',
    background_tooltip: '#f6f6f6',
    background: '#f6f6f6',
    bracket_background_default: '#24242D',
    bracket_background_loser: '#1F1E25',
    bracket_match_selection: 'linear-gradient(90deg, #fa6400 0%, #ffddc7 50%, #fa6400 100%)',
    bracket_minimap_background: '#262631',
    bracket_minimap_border: '#52525E',
    bracket_minimap_content: '#39394A',
    bracket_minimap_viewport_border: '#6769EB',
    bracket_liaison: '#cfcece',
    component_gauge_background: '#d6d6d6',
    component_gauge_circle_background: '#d6d6d6',
    component_live_tag_text: '#f6f6f6',
    component_live_tag: '#fe257e',
    component_radar_team_1: '#fe257e',
    component_radar_team_2: '#06d6a0',
    component_timeline_lines: '#6C6C75',
    data_loser: '#ED5565',
    data_strong: '#fe257e',
    data_tie: '#FFB333',
    data_weak: '#ffbed8',
    data_winner: '#05c489',
    error_accent: '#fe257e',
    error_back: 'rgba(254, 37, 126, 0.3)',
    font_family_titles: 'avenir',
    font_family: 'avenir',
    global_background_protection:
      'linear-gradient(-90deg, rgba(235, 235, 235, 0) 10%, rgb(235, 235, 235) 40%, rgb(235, 235, 235) 60%, rgba(235, 235, 235, 0) 90%)',
    global_border: '#cfcece',
    global_focus: '#fe257e',
    global_image_blur: 'rgb(246, 246, 246) 50%, rgba(246, 246, 246, 0) 100%',
    global_map_image_blur: 'rgba(255, 255, 255, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#000055',
    text_overlay_secondary: '#6c6c75',
    text_overlay: '#000055',
    text_secondary: '#6c6c75',
    text_tertiary: '#5c5c5c',
    text_title: '#000055',
    text: '#000055',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(71, 71, 255, 0.6)',
    vg_lol_blue: '#4747ff',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(255, 74, 75, 0.6)',
    vg_lol_red: '#ff4a4b',
    vg_lol_water_drake: '#87B6A7'
  },
  onetop: {
    mode: 'dark',
    background_avatar: '#0c0f16',
    background_secondary: '#0b0e16',
    background_tooltip: '#0e121a',
    background: '#1c222c',
    bracket_background_default: '#24242D',
    bracket_background_loser: '#1F1E25',
    bracket_match_selection: 'linear-gradient(90deg, #fa6400 0%, #ffddc7 50%, #fa6400 100%)',
    bracket_minimap_background: '#262631',
    bracket_minimap_border: '#52525E',
    bracket_minimap_content: '#39394A',
    bracket_minimap_viewport_border: '#6769EB',
    bracket_liaison: '#222a33',
    component_gauge_background: '#242c38',
    component_gauge_circle_background: '#242c38',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#ff2424',
    component_radar_team_1: '#ff9b14',
    component_radar_team_2: '#15a9fe',
    component_timeline_lines: '#C0C0C4',
    data_loser: '#e05531',
    data_strong: '#15a9fe',
    data_tie: '#ffff71',
    data_weak: '#9ad9fe',
    data_winner: '#a4ed9f',
    error_accent: '#15a9fe',
    error_back: '#242c38',
    font_family_titles: 'NanumGothic',
    font_family: 'NanumGothic',
    global_background_protection: 'transparent',
    global_border: '#222a33',
    global_focus: '#15a9fe',
    global_image_blur: 'rgb(28, 34, 44) 50%, rgba(28, 34, 44, 0) 100%',
    global_map_image_blur: 'rgba(28, 34, 44, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#15a9fe',
    text_overlay_secondary: '#89878C',
    text_overlay: '#FFFFFF',
    text_secondary: '#89878C',
    text_tertiary: '#C0C0C4',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  winline: {
    mode: 'dark',
    background_avatar: '#1F1E25',
    background_secondary: '#1F1E25',
    background_tooltip: '#242424',
    background: '#141419',
    bracket_background_default: '#2C2C30',
    bracket_background_loser: '#202025',
    bracket_match_selection: 'linear-gradient(90deg, #8A3FFC 0%, #5B0AD6 100%)',
    bracket_minimap_background: '#2C2C30',
    bracket_minimap_border: '#4C4C4F',
    bracket_minimap_content: '#565659',
    bracket_minimap_viewport_border: '#8A3FFC',
    bracket_liaison: '#37373C',
    component_gauge_background: '#292929',
    component_gauge_circle_background: '#292929',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#8A3FFC',
    component_radar_team_1: '#8A3FFC',
    component_radar_team_2: '#FACF00',
    component_timeline_lines: '#37373C',
    data_loser: '#C75A4C',
    data_strong: '#FACF00',
    data_tie: '#FFB333',
    data_weak: 'rgba(250, 207, 0, 0.4)',
    data_winner: '#34A74D',
    error_accent: '#8A3FFC',
    error_back: 'rgba(138, 63, 252, 0.3)',
    font_family_titles: 'SFProDisplay',
    font_family: 'SFProDisplay',
    global_background_protection: 'transparent',
    global_border: '#211F27',
    global_focus: '#35343B',
    global_image_blur: 'rgba(28, 34, 44, 1) 50%, rgba(11, 14, 22, 0) 100%',
    global_map_image_blur: 'rgba(20, 19, 43, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#8A3FFC',
    text_overlay_secondary: 'rgba(255, 255, 255, 0.7)',
    text_overlay: '#FFFFFF',
    text_secondary: '#89878C',
    text_tertiary: '#C0C0C4',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  kara: {
    mode: 'dark',
    background_avatar: '#353271',
    background_secondary: '#242424',
    background_tooltip: '#242424',
    background: '#343434',
    bracket_background_default: '#242424',
    bracket_background_loser: '#292929',
    bracket_match_selection: 'linear-gradient(90deg, #FACF00 0%, #FFFFFF 50%, #FACF00 100%)',
    bracket_minimap_background: '#242424',
    bracket_minimap_border: '#292929',
    bracket_minimap_content: '#4E4D56',
    bracket_minimap_viewport_border: '#FACF00',
    bracket_liaison: '#292929',
    component_gauge_background: '#292929',
    component_gauge_circle_background: '#292929',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#FACF00',
    component_radar_team_1: '#8467EB',
    component_radar_team_2: '#FACF00',
    component_timeline_lines: '#89878C',
    data_loser: '#EA7272',
    data_strong: '#FACF00',
    data_tie: '#FFB333',
    data_weak: 'rgba(250,207,0,0.4)',
    data_winner: '#7BDB92',
    error_accent: '#FACF00',
    error_back: 'rgba(250,207,0,0.3)',
    font_family_titles: 'NanumGothic',
    font_family: 'NanumGothic',
    global_background_protection: 'transparent',
    global_border: '#292929',
    global_focus: '#353271',
    global_image_blur: 'rgb(0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%',
    global_map_image_blur: 'rgba(20,19,43,0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#FACF00',
    text_overlay_secondary: 'rgba(255, 255, 255, 0.7)',
    text_overlay: '#FFFFFF',
    text_secondary: 'rgba(255, 255, 255, 0.7)',
    text_tertiary: '#C0C0C4',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  csgorun: {
    mode: 'dark',
    background_avatar: '#353271',
    background_secondary: '#282F4A',
    background_tooltip: '#262F4C',
    background: '#1D2338',
    bracket_background_default: '#262F4C',
    bracket_background_loser: '#242942',
    bracket_match_selection: 'linear-gradient(90deg, #4DF9B4 0%, #B3FDE0 50%, #4DF9B4 100%)',
    bracket_minimap_background: '#262F4C',
    bracket_minimap_border: '#252D4A',
    bracket_minimap_content: '#333B5C',
    bracket_minimap_viewport_border: '#B3FDE0',
    bracket_liaison: '#252D4A',
    component_gauge_background: '#353271',
    component_gauge_circle_background: '#353271',
    component_live_tag_text: '#1D2338',
    component_live_tag: '#B3FDE0',
    component_radar_team_1: '#6769EB',
    component_radar_team_2: '#06D6A0',
    component_timeline_lines: '#89878C',
    data_loser: '#EA7272',
    data_strong: '#B3FDE0',
    data_tie: '#FFB333',
    data_weak: '#B3FDE066',
    data_winner: '#7BDB92',
    error_accent: '#B3FDE0',
    error_back: 'rgba(179, 253, 224, 0.3)',
    font_family_titles: 'Inter',
    font_family: 'Inter',
    global_background_protection: 'transparent',
    global_border: '#252D4A',
    global_focus: '#B3FDE0',
    global_image_blur: 'rgb(24, 27, 45) 50%, rgba(24, 27, 45, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #2E2C63 0%, #181B2D 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#B3FDE0',
    text_overlay_secondary: '#FFFFFFB2',
    text_overlay: '#FFFFFF',
    text_secondary: '#FFFFFFB2',
    text_tertiary: '#A3A1A5',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  pariru: {
    mode: 'dark',
    background_avatar: 'rgba(0, 199, 177, 0.3)',
    background_secondary: '#171717',
    background_tooltip: '#35343B',
    background: '#0D0D0C',
    bracket_background_default: '#252525',
    bracket_background_loser: '#1E1E1E',
    bracket_match_selection: 'linear-gradient(90deg, #fa6400 0%, #ffddc7 50%, #fa6400 100%)',
    bracket_minimap_background: '#1E1E1E',
    bracket_minimap_border: '#211F27',
    bracket_minimap_content: '#333333',
    bracket_minimap_viewport_border: '#49DEFF',
    bracket_liaison: '#70E5FF',
    component_gauge_background: '#2F2E38',
    component_gauge_circle_background: '#2F2E38',
    component_live_tag_text: '#1A1E25',
    component_live_tag: '#FCD700',
    component_radar_team_1: '#6769EB',
    component_radar_team_2: '#06D6A0',
    component_timeline_lines: '#89878C',
    data_loser: '#ED5565',
    data_strong: '#6769EB',
    data_tie: '#FFB333',
    data_weak: '#A5A7E7',
    data_winner: '#03B19E',
    design_team_1: '#00C7B1',
    design_team_1_background: '#0C281E',
    design_team_1_text_overlay: '#00C7B1',
    design_team_1_box_background_start: 'rgba(0, 107, 95, 0.5)',
    design_team_1_box_background_end: 'rgba(0, 199, 177, 0.6)',
    design_team_1_box_text: '#FFFFFF',
    design_team_1_gradient_start: '#C3EBC4',
    design_team_1_gradient_end: '#18BAA8',
    design_team_2: '#49DEFF',
    design_team_2_background: '#00313D',
    design_team_2_text_overlay: '#49DEFF',
    design_team_2_box_background_start: 'rgba(73, 222, 255, 0.5)',
    design_team_2_box_background_end: 'rgba(0, 49, 61, 0.6)',
    design_team_2_box_text: '#FFFFFF',
    design_team_2_gradient_start: '#EBFBFF',
    design_team_2_gradient_end: '#49DEFF',
    design_background_header: '#171717',
    design_background_active_tab: '#252525',
    error_accent: '#00C7B1',
    error_back: '#00C7B14D',
    font_family_titles: 'Montserrat',
    font_family: 'Montserrat',
    global_background_protection: 'transparent',
    global_border: '#2E2E2E',
    global_focus: '#89878C',
    global_image_blur: 'rgb(22, 21, 27) 50%, rgba(22, 21, 27, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.7)',
    global_no_image_gradient: 'linear-gradient(180deg, rgba(80, 78, 96, 0) 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#EBFBFF',
    text_overlay_secondary: '#89878C',
    text_overlay: '#FFFFFF',
    text_secondary: '#A3A3A3',
    text_tertiary: '#464646',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  'pariru-light': {
    mode: 'light',
    background_avatar: 'rgba(0, 199, 177, 0.5)',
    background_secondary: '#F3F5F7',
    background_tooltip: '#DFE4EA',
    background: '#FFFFFF',
    bracket_background_default: '#ECEFF3',
    bracket_background_loser: '#DFE4EA',
    bracket_match_selection: 'linear-gradient(90deg, #fa6400 0%, #ffddc7 50%, #fa6400 100%)',
    bracket_minimap_background: '#DFE4EA',
    bracket_minimap_border: '#AAB1BD',
    bracket_minimap_content: '#FFFFFF',
    bracket_minimap_viewport_border: '#49DEFF',
    bracket_liaison: '#70E5FF',
    component_gauge_background: '#FFFFFF',
    component_gauge_circle_background: '#FFFFFF',
    component_live_tag_text: '#1A1E25',
    component_live_tag: '#FCD700',
    component_radar_team_1: '#6769EB',
    component_radar_team_2: '#06D6A0',
    component_timeline_lines: '#DFE4EA',
    data_loser: '#ED5565',
    data_strong: '#6769EB',
    data_tie: '#FFB333',
    data_weak: '#A5A7E7',
    data_winner: '#03B19E',
    design_team_1: '#00C7B1',
    design_team_1_background: '#E4FFF5',
    design_team_1_text_overlay: '#9FEAE1',
    design_team_1_box_background_start: '#9FEAE1',
    design_team_1_box_background_end: '#9FEAE1',
    design_team_1_box_text: '#1A1E25',
    design_team_1_gradient_start: '#C3EBC4',
    design_team_1_gradient_end: '#18BAA8',
    design_team_2: '#2ABAD8',
    design_team_2_background: '#EBFBFF',
    design_team_2_text_overlay: '#2ABAD8',
    design_team_2_box_background_start: '#ADF0FF',
    design_team_2_box_background_end: '#ADF0FF',
    design_team_2_box_text: '#1A1E25',
    design_team_2_gradient_start: '#D6F7FF',
    design_team_2_gradient_end: '#2ABAD8',
    design_background_header: '#1F2832',
    design_background_active_tab: '#2E3B4D',
    error_accent: '#00C7B1',
    error_back: '#00C7B14D',
    font_family_titles: 'Montserrat',
    font_family: 'Montserrat',
    global_background_protection: 'transparent',
    global_border: '#DFE4EA',
    global_focus: '#AAB1BD',
    global_image_blur: 'rgb(46, 59, 77) 50%, rgba(23, 30, 40, 0) 100%',
    global_map_image_blur: 'rgba(34, 43, 55, 0.8)',
    global_no_image_gradient: 'linear-gradient(180deg, rgba(23, 30, 40, 0) 0%, #171E28 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#FFFFFF',
    text_overlay_secondary: '#CECECE',
    text_overlay: '#FFFFFF',
    text_secondary: '#5E6A78',
    text_tertiary: '#AAB1BD',
    text_title: '#1A1E25',
    text: '#1A1E25',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  'betcity-dark': {
    mode: 'dark',
    background_avatar: 'rgba(165, 167, 231, 0.3)',
    background_secondary: '#1F1E25',
    background_tooltip: '#35343B',
    background: '#000000',
    bracket_background_default: '#24242D',
    bracket_background_loser: '#1F1E25',
    bracket_match_selection: 'linear-gradient(90deg, #3472A1 0%, #b5cde0 50%, #3472A1 100%)',
    bracket_minimap_background: '#262631',
    bracket_minimap_border: '#52525e',
    bracket_minimap_content: '#39394A',
    bracket_minimap_viewport_border: '#3472a1',
    bracket_liaison: '#211F27',
    component_gauge_background: '#2F2E38',
    component_gauge_circle_background: '#2F2E38',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#3472a1',
    component_radar_team_1: '#4098c6',
    component_radar_team_2: '#b96fb2',
    component_timeline_lines: '#89878C',
    data_loser: '#ED5565',
    data_strong: '#5795c7',
    data_tie: '#FFB333',
    data_weak: 'rgba(71, 120, 158, 0.6)',
    data_winner: '#35FFC6',
    error_accent: '#3472a1',
    error_back: 'rgba(165, 167, 231, 0.3)',
    font_family_titles: 'Roboto',
    font_family: 'Roboto',
    global_background_protection: 'transparent',
    global_border: '#211F27',
    global_focus: '#89878C',
    global_image_blur: 'rgb(22, 21, 27) 50%, rgba(22, 21, 27, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#3472a1',
    text_overlay_secondary: '#89878C',
    text_overlay: '#FFFFFF',
    text_secondary: '#999999',
    text_tertiary: '#C0C0C4',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  'betcity-light': {
    mode: 'light',
    background_avatar: 'rgba(52, 114, 161, 0.3)',
    background_secondary: '#F4F7FA',
    background_tooltip: '#EEF0F0',
    background: '#FFFFFF',
    bracket_background_default: '#f4f7fa',
    bracket_background_loser: '#F4F5F6',
    bracket_match_selection: 'linear-gradient(90deg, #3472A1 0%, #b5cde0 50%, #3472A1 100%)',
    bracket_minimap_background: '#f4f7fa',
    bracket_minimap_border: '#e7e7e7',
    bracket_minimap_content: '#cccdcd',
    bracket_minimap_viewport_border: '#3472a1',
    bracket_liaison: '#e7e7e7',
    component_gauge_background: '#F4F7FA',
    component_gauge_circle_background: '#F4F7FA',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#3472A1',
    component_radar_team_1: '#4098c6',
    component_radar_team_2: '#b96fb2',
    component_timeline_lines: '#979797',
    data_loser: '#e22b12',
    data_strong: '#3472a1',
    data_tie: '#FFB333',
    data_weak: 'rgba(52, 114, 161, 0.6)',
    data_winner: '#0a8a13',
    error_accent: '#3472a1',
    error_back: 'rgba(52, 114, 161, 0.3)',
    font_family_titles: 'Roboto',
    font_family: 'Roboto',
    global_background_protection: 'transparent',
    global_border: '#e7e7e7',
    global_focus: '#89878C',
    global_image_blur: 'rgba(0, 0, 0, 0.8) 50%, rgba(255, 255, 255, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #F4F7FA 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#3472a1',
    text_overlay_secondary: '#ffffff',
    text_overlay: '#ffffff',
    text_secondary: '#595959',
    text_tertiary: '#707070',
    text_title: '#222222',
    text: '#222222',
    vg_cs_counterterro_weak: 'rgba(43, 123, 177, 0.6)',
    vg_cs_counterterro: '#2b7bb1',
    vg_cs_terro_weak: 'rgba(149, 111, 15, 0.6)',
    vg_cs_terro: '#956f0f',
    vg_dota_dire: '#f8afa5',
    vg_dota_radiant: '#75e59c',
    vg_lol_blue_weak: 'rgba(140, 193, 221, 0.6)',
    vg_lol_blue: '#8cc1dd',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(206, 151, 162, 0.6)',
    vg_lol_red: '#ce97a2',
    vg_lol_water_drake: '#87B6A7'
  },
  'bet-pandascore': {
    mode: 'dark',
    background_avatar: 'rgba(22, 231, 207, 0.1)',
    background_secondary: '#242528',
    background_tooltip: '#18191a',
    background: '#1f1f21',
    bracket_background_default: '#303236',
    bracket_background_loser: '#26282b',
    bracket_match_selection: 'linear-gradient(90deg, #fa6400 0%, #ffddc7 50%, #fa6400 100%)',
    bracket_minimap_background: '#18191a',
    bracket_minimap_border: '#37373a',
    bracket_minimap_content: '#242528',
    bracket_minimap_viewport_border: '#16e7cf',
    bracket_liaison: '#37373a',
    component_gauge_background: '#2b2c2f',
    component_gauge_circle_background: '#2b2c2f',
    component_live_tag_text: '#1f1f21',
    component_live_tag: '#16e7cf',
    component_radar_team_1: '#6769EB',
    component_radar_team_2: '#06D6A0',
    component_timeline_lines: '#37373a',
    data_loser: '#ED5565',
    data_strong: '#16e7cf',
    data_tie: '#FFB333',
    data_weak: 'rgba(22, 231, 207, 0.3)',
    data_winner: '#35FFC6',
    error_accent: '#16e7cf',
    error_back: 'rgba(22, 231, 207, 0.2)',
    font_family_titles: 'avenir',
    font_family: 'avenir',
    global_background_protection: 'transparent',
    global_border: '#37373a',
    global_focus: '#59595f',
    global_image_blur: 'rgb(22, 21, 27) 50%, rgba(22, 21, 27, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#16e7cf',
    text_overlay_secondary: '#949597',
    text_overlay: '#e3e4e5',
    text_secondary: '#949597',
    text_tertiary: '#a2a3a4',
    text_title: '#e3e4e5',
    text: '#e3e4e5',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  'trading-light-pandascore': {
    mode: 'light',
    background_avatar: 'rgba(51, 153, 244, 0.1)',
    background_secondary: '#F4F7FA',
    background_tooltip: '#EAEEF3',
    background: '#FFFFFF',
    bracket_background_default: '#303236',
    bracket_background_loser: '#26282B',
    bracket_match_selection: 'linear-gradient(90deg, #16E7CF 0%, #FFFFFF 50%, #16E7CF 100%)',
    bracket_minimap_background: '#EAEEF3',
    bracket_minimap_border: '#DFE1EC',
    bracket_minimap_content: '#242528',
    bracket_minimap_viewport_border: '#16E7CF',
    bracket_liaison: '#DFE1EC',
    component_gauge_background: '#EAEEF3',
    component_gauge_circle_background: '#939393',
    component_live_tag_text: '#1F1F21',
    component_live_tag: '#7BD389',
    component_radar_team_1: '#6769EB',
    component_radar_team_2: '#06D6A0',
    component_timeline_lines: '#5F5F5F',
    data_loser: '#ED5565',
    data_strong: '#16E7CF',
    data_tie: '#FFB333',
    data_weak: 'rgba(22, 231, 207, 0.3)',
    data_winner: '#35FFC6',
    error_accent: '#3399F4',
    error_back: 'rgba(51, 153, 244, 0.2)',
    font_family_titles: 'avenir',
    font_family: 'avenir',
    global_background_protection: 'transparent',
    global_border: '#DFE1EC',
    global_focus: '#5F6E85',
    global_image_blur: 'rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #F4F7FA 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#3399F4',
    text_overlay_secondary: '#FFFFFF',
    text_overlay: '#FFFFFF',
    text_secondary: '#5F6E85',
    text_tertiary: '#1F1F21',
    text_title: '#333333',
    text: '#333333',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  'trading-dark-pandascore': {
    mode: 'dark',
    background_avatar: 'rgba(100, 178, 247, 0.1)',
    background_secondary: '#1B1B22',
    background_tooltip: '#363644',
    background: '#24242D',
    bracket_background_default: '#303236',
    bracket_background_loser: '#26282B',
    bracket_match_selection: 'linear-gradient(90deg, #16E7CF 0%, #FFFFFF 50%, #16E7CF 100%)',
    bracket_minimap_background: '#363644',
    bracket_minimap_border: '#40404F',
    bracket_minimap_content: '#242528',
    bracket_minimap_viewport_border: '#16E7CF',
    bracket_liaison: '#40404F',
    component_gauge_background: '#40404F',
    component_gauge_circle_background: '#2B2C2F',
    component_live_tag_text: '#1F1F21',
    component_live_tag: '#7BD389',
    component_radar_team_1: '#6769EB',
    component_radar_team_2: '#06D6A0',
    component_timeline_lines: '#37373A',
    data_loser: '#ED5565',
    data_strong: '#16E7CF',
    data_tie: '#FFB333',
    data_weak: 'rgba(22, 231, 207, 0.3)',
    data_winner: '#35FFC6',
    error_accent: '#64B2F7',
    error_back: 'rgba(100, 178, 247, 0.2)',
    font_family_titles: 'avenir',
    font_family: 'avenir',
    global_background_protection: 'transparent',
    global_border: '#40404F',
    global_focus: 'rgba(255, 255, 255, 0.6)',
    global_image_blur: 'rgb(36, 36, 45) 50%, rgba(36, 36, 45, 0) 100%',
    global_map_image_blur: 'rgba(0, 0, 0, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1B1B22 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#64B2F7',
    text_overlay_secondary: '#FFFFFF',
    text_overlay: '#FFFFFF',
    text_secondary: 'rgba(255, 255, 255, 0.6)',
    text_tertiary: '#1F1F21',
    text_title: 'rgba(255, 255, 255, 0.8)',
    text: 'rgba(255, 255, 255, 0.8)',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  tting: {
    mode: 'dark',
    background_avatar: '#242424',
    background_secondary: '#232323',
    background_tooltip: '#0e121a',
    background: '#28282a',
    bracket_background_default: '#0e121a',
    bracket_background_loser: '#181d25',
    bracket_match_selection: 'linear-gradient(90deg, #02F580 0%, #CEFDE6 50%, #02F580 100%)',
    bracket_minimap_background: '#0e121a',
    bracket_minimap_border: '#222a33',
    bracket_minimap_content: '#1B1E2A',
    bracket_minimap_viewport_border: '#CEFDE6',
    bracket_liaison: '#383838',
    component_gauge_background: '#242c38',
    component_gauge_circle_background: '#343434',
    component_live_tag_text: '#000000',
    component_live_tag: '#02F580',
    component_radar_team_1: '#02F580',
    component_radar_team_2: '#f2f2f2',
    component_timeline_lines: '#222a33',
    data_loser: '#EA7272',
    data_strong: '#02F580',
    data_tie: '#ffff71',
    data_weak: 'rgba(2, 245, 128, 0.4)',
    data_winner: '#7BDB92',
    error_accent: '#15A9FE',
    error_back: '#242C38',
    font_family_titles: 'NanumGothic',
    font_family: 'NanumGothic',
    global_background_protection: 'transparent',
    global_border: '#383838',
    global_focus: '#02f580',
    global_image_blur: '#1C222C 50%, rgba(11, 14, 22, 0) 100%',
    global_map_image_blur: 'rgba(23, 24, 40, 0.2)',
    global_no_image_gradient: 'linear-gradient(180deg, #504E60 0%, #1F1E25 100%)',
    microbetting_highlight: '#38F9D7',
    microbetting_highlighted_selection_hover: '#07EDBF',
    microbetting_highlighted_text: '#2C2C2C',
    microbetting_selection: '#363644',
    microbetting_settlement_correct: '#3FD993',
    microbetting_settlement_wrong: '#FF4F55',
    text_avatar_acronym: '#02f580',
    text_overlay_secondary: '#FFFFFF',
    text_overlay: '#FFFFFF',
    text_secondary: 'rgba(255, 255, 255, 0.7)',
    text_tertiary: '#C0C0C4',
    text_title: '#FFFFFF',
    text: '#FFFFFF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#D3EB6F',
    vg_lol_cloud_drake: '#CCDBDC',
    vg_lol_elder_drake: '#9984D4',
    vg_lol_fire_drake: '#F7D08A',
    vg_lol_hextech_drake: '#80CED7',
    vg_lol_mountain_drake: '#B27C66',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#87B6A7'
  },
  'bet-eu_dark': {
    background_avatar: 'rgba(90, 196, 93, 0.1)',
    background_secondary: '#1D2126',
    background_tooltip: '#333945',
    background: '#272C33',
    bracket_background_default: '#FFFFFF',
    bracket_background_loser: '#FFFFFF',
    bracket_liaison: '#FFFFFF',
    bracket_match_selection: 'linear-gradient(90deg, #FFFFFF 0%, #FFFFFF 50%, #FFFFFF 100%)',
    bracket_minimap_background: '#FFFFFF',
    bracket_minimap_border: '#FFFFFF',
    bracket_minimap_content: '#FFFFFF',
    bracket_minimap_viewport_border: '#FFFFFF',
    component_gauge_background: '#333945',
    component_gauge_circle_background: '#333945',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#5AC45D',
    component_radar_team_1: '#5AC45D',
    component_radar_team_2: '#5580ED',
    component_timeline_lines: '#363A45',
    data_loser: '#ED5565',
    data_strong: '#5AC45D',
    data_tie: '#FFB333',
    data_weak: 'rgba(90, 196, 93, 0.3)',
    data_winner: '#66CC77',
    error_accent: '#5AC45D',
    error_back: 'rgba(90, 196, 93, 0.2)',
    font_family_titles: 'Industry, Inter',
    font_family: 'Flama, Inter',
    global_background_protection: 'transparent',
    global_border: '#363A45',
    global_focus: '#E3E4E5',
    global_image_blur: 'rgb(39, 44, 51) 50%, rgba(39, 44, 51, 0) 100%',
    global_map_image_blur: 'rgba(29, 33, 38, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #333945 0%, #1D2126 100%)',
    microbetting_highlight: '#FFFFFF',
    microbetting_highlighted_selection_hover: '#FFFFFF',
    microbetting_highlighted_text: '#FFFFFF',
    microbetting_selection: '#FFFFFF',
    microbetting_settlement_correct: '#FFFFFF',
    microbetting_settlement_wrong: '#FFFFFF',
    mode: 'dark',
    text_avatar_acronym: '#5AC45D',
    text_overlay_secondary: 'rgba(255, 255, 255, 0.7)',
    text_overlay: '#FFFFFF',
    text_secondary: '#949597',
    text_tertiary: '#FFFFFF',
    text_title: '#E3E4E5',
    text: '#E3E4E5',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#ADBF60',
    vg_lol_cloud_drake: '#848989',
    vg_lol_elder_drake: '#9474ED',
    vg_lol_fire_drake: '#F3C165',
    vg_lol_hextech_drake: '#83D4DD',
    vg_lol_mountain_drake: '#D49D87',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#83DCC0'
  },
  'bet-asia': {
    background_avatar: 'rgba(72, 213, 91, 0.1)',
    background_secondary: '#FFFFFF',
    background_tooltip: '#FFFFFF',
    background: '#F2F4F6',
    bracket_background_default: '#FFFFFF',
    bracket_background_loser: '#FFFFFF',
    bracket_liaison: '#FFFFFF',
    bracket_match_selection: 'linear-gradient(90deg, #FFFFFF 0%, #FFFFFF 50%, #FFFFFF 100%)',
    bracket_minimap_background: '#FFFFFF',
    bracket_minimap_border: '#FFFFFF',
    bracket_minimap_content: '#FFFFFF',
    bracket_minimap_viewport_border: '#FFFFFF',
    component_gauge_background: '#E3EBE8',
    component_gauge_circle_background: '#BECFCA',
    component_live_tag_text: '#16151B',
    component_live_tag: '#48D55B',
    component_radar_team_1: '#48D55B',
    component_radar_team_2: '#5580ED',
    component_timeline_lines: '#BECFCA',
    data_loser: '#ED5565',
    data_strong: '#48D55B',
    data_tie: '#FFB333',
    data_weak: 'rgba(72, 213, 91, 0.3)',
    data_winner: '#66CC77',
    error_accent: '#125742',
    error_back: '#C7E6CC',
    font_family_titles: 'Poppins',
    font_family: 'Roboto',
    global_background_protection: 'transparent',
    global_border: '#BECFCA',
    global_focus: '#125742',
    global_image_blur: 'rgb(22, 21, 27) 50%, rgba(22, 21, 27, 0) 100%',
    global_map_image_blur: 'rgba(10, 51, 39, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #C7E6CC 0%, #F2F4F6 100%)',
    microbetting_highlight: '#FFFFFF',
    microbetting_highlighted_selection_hover: '#FFFFFF',
    microbetting_highlighted_text: '#FFFFFF',
    microbetting_selection: '#FFFFFF',
    microbetting_settlement_correct: '#FFFFFF',
    microbetting_settlement_wrong: '#FFFFFF',
    mode: 'light',
    text_avatar_acronym: '#125742',
    text_overlay_secondary: 'rgba(255, 255, 255, 0.7)',
    text_overlay: '#FFFFFF',
    text_secondary: '#919296',
    text_tertiary: '#16151B',
    text_title: '#16151B',
    text: '#16151B',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#ADBF60',
    vg_lol_cloud_drake: '#848989',
    vg_lol_elder_drake: '#9474ED',
    vg_lol_fire_drake: '#F3C165',
    vg_lol_hextech_drake: '#83D4DD',
    vg_lol_mountain_drake: '#D49D87',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#83DCC0'
  },
  'bet-usa': {
    background_avatar: 'rgba(254, 145, 72, 0.1)',
    background_secondary: '#010717',
    background_tooltip: '#1E2840',
    background: '#141C2E',
    bracket_background_default: '#FFFFFF',
    bracket_background_loser: '#FFFFFF',
    bracket_liaison: '#FFFFFF',
    bracket_match_selection: 'linear-gradient(90deg, #FFFFFF 0%, #FFFFFF 50%, #FFFFFF 100%)',
    bracket_minimap_background: '#FFFFFF',
    bracket_minimap_border: '#FFFFFF',
    bracket_minimap_content: '#FFFFFF',
    bracket_minimap_viewport_border: '#FFFFFF',
    component_gauge_background: '#323C50',
    component_gauge_circle_background: '#323C50',
    component_live_tag_text: '#0E1425',
    component_live_tag: '#FE9148',
    component_radar_team_1: '#FE9148',
    component_radar_team_2: '#3B82F6',
    component_timeline_lines: '#323C50',
    data_loser: '#FF9B99',
    data_strong: '#FE9148',
    data_tie: '#FFB333',
    data_weak: 'rgba(254, 145, 72, 0.3)',
    data_winner: '#89D2A5',
    error_accent: '#FE9148',
    error_back: 'rgba(254, 145, 72, 0.2)',
    font_family_titles: 'FiraSans',
    font_family: 'FiraSans',
    global_background_protection: 'transparent',
    global_border: '#323C50',
    global_focus: '#E9EBEF',
    global_image_blur: 'rgb(20, 28, 46) 50%, rgba(20, 28, 46, 0) 100%',
    global_map_image_blur: 'rgba(29, 33, 38, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #323C50 0%, #010717 100%)',
    microbetting_highlight: '#FFFFFF',
    microbetting_highlighted_selection_hover: '#FFFFFF',
    microbetting_highlighted_text: '#FFFFFF',
    microbetting_selection: '#FFFFFF',
    microbetting_settlement_correct: '#FFFFFF',
    microbetting_settlement_wrong: '#FFFFFF',
    mode: 'dark',
    text_avatar_acronym: '#FE9148',
    text_overlay_secondary: 'rgba(255, 255, 255, 0.7)',
    text_overlay: '#FFFFFF',
    text_secondary: '#8B909B',
    text_tertiary: '#0E1425',
    text_title: '#E9EBEF',
    text: '#E9EBEF',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#ADBF60',
    vg_lol_cloud_drake: '#848989',
    vg_lol_elder_drake: '#9474ED',
    vg_lol_fire_drake: '#F3C165',
    vg_lol_hextech_drake: '#83D4DD',
    vg_lol_mountain_drake: '#D49D87',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#83DCC0'
  },
  'bet-eu_light': {
    background_avatar: 'rgba(120, 111, 247, 0.1)',
    background_secondary: '#F3F4F6',
    background_tooltip: '#FFFFFF',
    background: '#FFFFFF',
    bracket_background_default: '#FFFFFF',
    bracket_background_loser: '#FFFFFF',
    bracket_liaison: '#FFFFFF',
    bracket_match_selection: 'linear-gradient(90deg, #FFFFFF 0%, #FFFFFF 50%, #FFFFFF 100%)',
    bracket_minimap_background: '#FFFFFF',
    bracket_minimap_border: '#FFFFFF',
    bracket_minimap_content: '#FFFFFF',
    bracket_minimap_viewport_border: '#FFFFFF',
    component_gauge_background: '#E0E0E1',
    component_gauge_circle_background: '#D7D9DC',
    component_live_tag_text: '#FFFFFF',
    component_live_tag: '#786FF7',
    component_radar_team_1: '#786FF7',
    component_radar_team_2: '#06D6A0',
    component_timeline_lines: '#D7D9DC',
    data_loser: '#ED5565',
    data_strong: '#786FF7',
    data_tie: '#FFB333',
    data_weak: 'rgba(120, 111, 247, 0.3)',
    data_winner: '#66CC77',
    error_accent: '#786FF7',
    error_back: '#EEEEFE',
    font_family_titles: 'SpaceGrotesk',
    font_family: 'IBMPlexSans',
    global_background_protection: 'transparent',
    global_border: '#E0E0E1',
    global_focus: '#786FF7',
    global_image_blur: 'rgb(22, 21, 27) 50%, rgba(22, 21, 27, 0) 100%',
    global_map_image_blur: 'rgba(12, 6, 96, 0.6)',
    global_no_image_gradient: 'linear-gradient(180deg, #F0F1F3 0%, #EEEEFE 100%)',
    microbetting_highlight: '#FFFFFF',
    microbetting_highlighted_selection_hover: '#FFFFFF',
    microbetting_highlighted_text: '#FFFFFF',
    microbetting_selection: '#FFFFFF',
    microbetting_settlement_correct: '#FFFFFF',
    microbetting_settlement_wrong: '#FFFFFF',
    mode: 'light',
    text_avatar_acronym: '#786FF7',
    text_overlay_secondary: 'rgba(255, 255, 255, 0.7)',
    text_overlay: '#FFFFFF',
    text_secondary: '#919296',
    text_tertiary: '#FFFFFF',
    text_title: '#1C1C1C',
    text: '#1C1C1C',
    vg_cs_counterterro_weak: 'rgba(51, 143, 206, 0.4)',
    vg_cs_counterterro: '#338FCE',
    vg_cs_terro_weak: 'rgba(239, 180, 29, 0.4)',
    vg_cs_terro: '#EFB41D',
    vg_dota_dire: '#F56476',
    vg_dota_radiant: '#16DB93',
    vg_lol_blue_weak: 'rgba(85, 128, 237, 0.6)',
    vg_lol_blue: '#5580ED',
    vg_lol_chemtech_drake: '#ADBF60',
    vg_lol_cloud_drake: '#848989',
    vg_lol_elder_drake: '#9474ED',
    vg_lol_fire_drake: '#F3C165',
    vg_lol_hextech_drake: '#83D4DD',
    vg_lol_mountain_drake: '#D49D87',
    vg_lol_red_weak: 'rgba(237, 85, 101, 0.6)',
    vg_lol_red: '#ED5565',
    vg_lol_water_drake: '#83DCC0'
  }
};

export default REGISTERED_THEMES;
